import { connect } from 'react-redux';
import { getAvailableEntertainments } from '../redux/actions/availableEntertainments';
import { getBookedEntertainments } from '../redux/actions/bookedEntertainments';
import { getBackstopDateFromApi } from '../redux/actions/backstopDate';
import {
  shouldFetch,
  getShouldFetchAvailableEntertainments,
  getShouldSkipSwimmingOrEntertainment,
  getIfAllowedToBook,
  filterActivitiesByBackstop,
  shouldFetchBackstopDate,
} from '../utils';
import Entertainment from '../components/entertainment/Entertainment';

const mapStateToProps = ({
  availableEntertainments,
  bookingSearch,
  bookedEntertainments,
  bookedEvents,
  config,
  backstopDate,
}, {
  isSummaryPage,
  detailPage,
}) => {
  const { departureDate, resId, siteCode, arrivalDate, isEarlyAccess, seasonSuffix = '' } = bookingSearch;
  const { isAllowedToBookEntertainment } = getIfAllowedToBook(bookingSearch, config);

  return {
    entertainments: filterActivitiesByBackstop(
      availableEntertainments.entertainments,
      config,
      departureDate,
      arrivalDate,
      seasonSuffix,
      isEarlyAccess,
      backstopDate.backstopDate,
    ),
    title: 'Setup your experience',
    subTitle: 'Entertainment',
    resId,
    siteCode,
    shouldFetchAvailableEntertainments: getShouldFetchAvailableEntertainments(availableEntertainments, bookedEntertainments, bookingSearch, config),
    shouldSkip: getShouldSkipSwimmingOrEntertainment(availableEntertainments.wasCalled, availableEntertainments.entertainments),
    shouldFetchBookedEntertainments: shouldFetch(bookedEntertainments, bookingSearch, config),
    bookedEvents: bookedEvents.events,
    isSummaryPage,
    detailPage,
    isAllowedToBookEntertainment,
    shouldFetchBackstopDate: shouldFetchBackstopDate(config, backstopDate, bookingSearch),
  };
};

const mapDispatchToProps = dispatch => ({
  getAvailableEntertainments: siteCode => dispatch(getAvailableEntertainments(siteCode)),
  getBookedEntertainments: (resId, siteCode) => dispatch(getBookedEntertainments(resId, siteCode)),
  getBackstopDateFromApi: () => dispatch(getBackstopDateFromApi()),
});

export default connect(mapStateToProps, mapDispatchToProps)(Entertainment);
